<template>
  <div class="projects-box">
    <menuBox :step="4"></menuBox>
    <div class="title-box">
      <div class="banner-text">
        <div class="bt">Hubungi kami</div>
        <div class="title">
          Melayani pelanggan dengan sepenuh hati
        </div>
        <div class="text">
          Untuk konsultasi dan kerjasama keuangan/asuransi dan bisnis lainnya, jangan ragu untuk menghubungi kami
        </div>
      </div>
    </div>
    <div class="contact-box">
      <div class="title">Kenalan</div>
      <div class="text">Hubungi kami</div>
      <textarea class="message" type="text" placeholder="Mesej …" />
      <div class="btn" @click="submit">Hantar</div>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "projects",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {
    };
  },
  mounted() { },
  methods: {
    submit() {
      alert('kejayaan!')
    }
  },
};
</script>
<style lang="less" scoped>
.projects-box {
  .title-box {
    background-image: url(../assets/projects.png);
    width: 100%;
    height: 640px;
    background-size: 100% 100%;
    overflow: hidden;
    box-sizing: border-box;

    .banner-text {
      padding: 250px 360px 0;
      box-sizing: border-box;

      .bt {
        margin-bottom: 10px;
        font-weight: 700;
        font-size: 48px;
        color: #333333;
        line-height: 68px;
      }

      .title {
        margin-bottom: 28px;
        font-size: 22px;
        color: #333333;
        line-height: 31px;
      }

      .text {
        font-size: 18px;
        color: #333333;
        line-height: 21px;
      }
    }
  }

  .contact-box {
    padding: 100px 360px;
    background: #F5A739;

    .title {
      margin-bottom: 24px;
      font-weight: 700;
      font-size: 32px;
      color: #FFFFFF;
      line-height: 45px;
    }

    .text {
      margin-bottom: 40px;
      font-size: 18px;
      color: #FFFFFF;
      line-height: 21px;
    }

    textarea {
      padding: 10px 20px;
      width: 600px;
      height: 140px;
      background: #FFFFFF;
      border-radius: 8px;
    }
  }

}

.btn {
  cursor: pointer;
  margin-top: 24px;
  width: 156px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  border-radius: 32px;
  border: 2px solid #FFFFFF;
  font-weight: 600;
  font-size: 16px;
  color: #FFFFFF;
}
</style>
